var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-auction-view-countdown"},[_c('AuctionCountdownTimer',{attrs:{"auction":_vm.auction,"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }